import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { RnhpVj } from "../../proctor/__generated__/ViewjobProctorSpecifications";
import { useViewJobDataContext } from "../context/ViewJobDataContext";
import { isJobFromHomePage, isJobFromSerp } from "../utils/fromParamUtils";

/**
 * Feature gate for full-screen viewjob. It takes full height on both iOS and Android (has corresponding native code for these)
 * and renders the same content as RNVJ inside, except a bottom ApplySection instead of a single apply button.
 */
export const useFullScreenVJActive = () => {
  const isFullScreenVJActiveFromRNHP = useViewjobProctorAllocation(RnhpVj).value >= 2;
  const isFullScreenVJActiveFromSERP = useViewjobProctorAllocation(RnhpVj).value === 5;
  const { from } = useViewJobDataContext();

  return (
    (isJobFromHomePage(from) && isFullScreenVJActiveFromRNHP) ||
    (isJobFromSerp(from) && isFullScreenVJActiveFromSERP)
  );
};
